import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import AddToCalendar from "react-add-to-calendar";
import {
    selectTasks,
    selectStepReflections, addTaskAsync, deleteTaskAsync, updateTaskAsync,
    updateTasks,
} from "../../slices/dashboardSlice";
import {Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Modal, Popconfirm, Row, TimePicker} from "antd";
import "./MyTasks.css";
import TaskComp from "./TaskComp";
import DraggablecompTI from "../Common/DraggablecompTI";
import {CloseOutlined, DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { stepsAutoUnlockObj } from "utils/steps";
import { stepKeyToPath } from "Components/Baselayout/StaticValues";
import DynamicSortDropdown from "Components/ReusableComponents/sorting";
import DynamicFilter from "Components/ReusableComponents/filter";
import useCustomizeDash from "hooks/useCustomizeDash";
import HELPERS from "utils/helper";
import DASHBOARD_API from "api/dashboard";
import enUS from "antd/lib/calendar/locale/en_US";

const Mytasks = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
    const tasks = useSelector(selectTasks);
    const stepReflections = useSelector(selectStepReflections);
    console.log('sss stepReflections', stepReflections)
    const [addToCal, setAddToCal] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const dispatch = useDispatch()
    const [addForm] = Form.useForm();
    const [taskId, setTaskId] = useState(null);
    const userId = HELPERS.getUserId();
    
    let task = [];
    let exists = {};
    const sortOptions = [
        { field: 'date', label: 'Due Date' },
        { field: 'status', label: 'Status' },
    ];

    const filterOptions = [
      // { key: 'completed', label: 'Completed', filterCondition: (task) => task.props.status === 'completed' },
    //   { key: 'overdue', label: 'Overdue', filterCondition: (task) => task.props.status === 'overdue' },
      { key: 'ongoing', label: 'In Progress', filterCondition: (task) => task.props.status === 'ongoing' },
      { key: 'review', label: 'Ready For Review', filterCondition: (task) => task.props.status === 'review' },
      { key: 'just-released', label: 'Not Started', filterCondition: (task) => task.props.status === 'just-released' },
    ];

    const [sortedData, setSortedData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [currentSortField, setCurrentSortField] = useState(null);
    const [currentSortOrder, setCurrentSortOrder] = useState(null);
    const [currentFilter, setCurrentFilter] = useState([]);
    const { isDropdownOpen } = useCustomizeDash();

    const [filteredData, setFilteredData] = useState([]);

    // Callback to handle sorting changes
    const handleSortChange = (sortedData, field, order) => {
      // setSortedData(sortedData);
      setCurrentSortField(field);
      setCurrentSortOrder(order);
      applyFilterAndSort(currentFilter, field, order);
    };
    const handlefilterChange = (sortedData, filterKey) => {
        // setSortedData(sortedData);
        setCurrentFilter(filterKey);
        applyFilterAndSort(filterKey, currentSortField, currentSortOrder);
    };

    const applyFilterAndSort = (filterKeys = currentFilter, sortField = currentSortField, sortOrder = currentSortOrder) => {
      // 1. Apply filters
      let filtered = [...originalData];
      if (filterKeys.length > 0) {
        filtered = originalData.filter(item =>
          filterKeys.some(key => {
            const filterOption = filterOptions.find(option => option.key === key);
            return filterOption ? filterOption.filterCondition(item) : true;
          })
        );
      }
    
      setFilteredData(filtered);
    
      // 2. Apply sorting
      let sorted = [...filtered];
      if (sortField && sortOrder) {
        sorted.sort((a, b) => {
          const valueA = a.props[sortField];
          const valueB = b.props[sortField];
    
          if (valueA === undefined || valueA === null || valueA === "") return 1;
          if (valueB === undefined || valueB === null || valueB === "") return -1;
    
          if (sortField === "status") {
            const orderMap = { ongoing: 1, "just-released": 2, overdue: 3, review: 4 };
            const aOrder = orderMap[valueA.toLowerCase()];
            const bOrder = orderMap[valueB.toLowerCase()];
            return sortOrder === "asc" ? aOrder - bOrder : bOrder - aOrder;
          }
    
          return sortOrder === "asc"
            ? valueA < valueB ? -1 : valueA > valueB ? 1 : 0
            : valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
        });
      }
    
      setSortedData(sorted);
    };    

    useEffect(() => {
        setAddToCal({
            title: "New Task",
            description: "",
            location: "",
            startTime: '',
            endTime: '',
        });
    }, [])

    const getStatus = (id) => {
        let status = "";

        if (id > 0 && stepReflections) {
            for (let k in stepReflections) {
                let reflection = stepReflections[k];
                if (reflection.id === id) {
                    if (reflection.notified === false) {
                        status = "just-released";
                    } else if (reflection.status === "ON") {
                        status = "ongoing";
                    } else if (reflection.status === "DO") {
                      status = "completed";
                    }
                }
            }
        }
        return status;
    };

    const handleDelete = () => {
      // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
      try {
        const payload = { "step_id": compID, "user_id": userId }
        console.log("sss delete", payload);
        DASHBOARD_API.deleteDashboardItem(payload)
        .then((response) => {
          console.log("sss delete api response", response);
          message.success("Your work has been saved")
          setTmpState(!tmpState)
        })
        .catch((err) => {
          console.log("sss delete api error", err, payload);
          message.error("Your work has not been saved")
        });
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    };

    const isLocked = (step) =>
        stepReflections[step] ? stepReflections[step].status === "LO" : false;

    const isUnlocked = (step) =>
        stepReflections[step] ? stepReflections[step].status === "UN" : false;
        
    const isReview = (step) =>
        stepReflections[step] ? stepReflections[step].status === "RE" : false;

    const isOngoing = (step) =>
        stepReflections[step] ? stepReflections[step].status === "ON" : false;

    const isDone = (step) =>
        stepReflections[step] ? stepReflections[step].status === "DO" : false;

    const isContinuous = (step) =>
        stepReflections[step] ? stepReflections[step].status === "CO" : false;

    const justLaunched = (step) =>
        stepReflections[step] ? isUnlocked(step) && stepReflections[step].notified === false : false;
        // stepReflections[step] ? stepReflections[step].status === "UN" : false;

    const dummyTasks = () => {
        let tasks = [];
        let exists = {};

        if (tasks) {
            for (let task of tasks) {
                if (task.stepReflection > 0) {
                    exists[task.stepReflection] = true;
                }
            }
        }
        if (stepReflections) {
            for (let k in stepReflections) {
                let reflection = stepReflections[k];
                // console.log('reflections',reflection);

                if (
                    reflection.step !== "ON" &&
                    reflection.step !== "MI" &&
                    reflection.step !== "NP" &&
                    reflection.step !== "AE" &&
                    reflection.step !== "JA" &&
                    reflection.step !== "GC"
                    // reflection.step !== "TR" &&
                    // reflection.step !== "TI" 
                    //  && !(NO_SUBMIT[reflection.step] && reflection.status!=="UN")
                ) {
                    // if (
                    //     exists[reflection.id] !== true &&
                    //     // !reflection.complete_by &&
                    //     (reflection.status === "ON" || reflection.status === "UN") &&
                    //     reflection.stepName.toLowerCase().indexOf("reflection") === -1
                    // ) {
                    if (
                        exists[reflection.id] !== true &&
                        // !reflection.complete_by &&
                        // (reflection.status === "ON" || reflection.status === "UN")
                        // (reflection.status !== "DO" && reflection.status !== "LO" && reflection.status !== "UN")
                        (reflection.status !== "DO" && reflection.status !== "LO")
                        && (reflection.assosciate_icons || !reflection.auto_unlock)
                        // && reflection.stepName.toLowerCase().indexOf("reflection") === -1
                    ) {
                        tasks.push(
                            <TaskComp
                                key={`${reflection.stepName}-${reflection.id}`}
                                title={reflection.stepName}
                                // title={stepsAutoUnlockObj[reflection.step].name}
                                date={reflection.complete_by}
                                stepId={reflection.id}
                                stepKey={reflection.step}
                                stepName={reflection.stepName}
                                status={
                                    // reflection.status === "ON" ? "ongoing" : "just-released"
                                    justLaunched(reflection.step) ? "just-released" : isDone(reflection.step) ? "done" : isOngoing(reflection.step) ? "ongoing" : isReview(reflection.step) ? "review" : isContinuous(reflection.step) ? "continuous" : "just-released"
                                }
                                id={-1}
                                linkURL={stepKeyToPath[reflection.step]}
                            />
                        );
                    }
                }
            }
        }
        return tasks;
    };
    useEffect(() => {
      const tasks = dummyTasks(); // Generate tasks using dummyTasks()
      const extraTasks = tasksList.filter(item => typeof item === 'object' && item !== null && !Array.isArray(item));

      // Combine both arrays
      const combinedTasks = [...tasks, ...extraTasks];

      // console.log('sss extraTasks', extraTasks, combinedTasks)

      if (combinedTasks.length > 0) {
          setSortedData(combinedTasks); // Set them into sortedData only if tasks are generated
          setOriginalData(combinedTasks)
          setFilteredData(combinedTasks)
      }
    }, [stepReflections, tasks]);

    const editTask = (id) => {
      setTaskId(id);
      const currentTask = tasks.find(task => task.id === id);
      console.log('sss currentTask', currentTask, id)

      addForm.setFieldsValue({
        id: currentTask.id,
        title: currentTask.title,
        // date: currentTask.assigned_on ? moment(currentTask.assigned_on) : moment(),
        date: moment(),
        enddate: currentTask.due_date ? moment(currentTask.due_date): null,
        duration: currentTask.duration,
        description: currentTask.description,
        hyperlinks: currentTask.hyperlinks.length > 0 ? currentTask.hyperlinks : [""],
      });
      setModalVisible(true);

      let start_date = moment(currentTask.due_date);
      console.log("start!!!!!!", start_date);

      setAddToCal({
        title: currentTask.title,
        description: currentTask.description,
        location: "",
        startTime: currentTask.due_date,
        endTime: start_date.add(currentTask.duration, "minutes").toDate(),
      });
    }
    console.log("Bolg!! I have a task for you", tasks);

    const checkReflection = (reflection) => {
      console.log(reflection.title.slice(0, 5));
      if (reflection.weekly_reflection) {
        if (
          moment().isAfter(moment(reflection.assigned_on)) &&
          moment(reflection.due_date).isAfter(moment())
        ){
          return true;
        }
        else return false;
      } else {
        return true;
      }
    };
    const getStatusOfTasks = (task) => {
      let status = "";
      if ( moment().isAfter(moment(task.assigned_on)) && moment(task.due_date).isAfter(moment() ) ){
        status = "ongoing"
      }
      else if( moment(task.assigned_on).isAfter(moment()) && moment(task.due_date).isAfter(moment()) ){
        status = "just-released"
      }
      else{
        status = "ongoing"
      }
      // console.log('sss props', status, task.title)
      return status;
    }
    const tasksList = tasks
        ? tasks.filter(task1 => {
            // console.log('sss props test1', task1, !(task1.step_reflection || task1.weekly_reflection))
            if (!(task1.step_reflection || task1.weekly_reflection)) {
            // if ((!task1.step_reflection && !task1.weekly_reflection)) {
              // if (!moment(task1.due_date).isAfter(moment()) && task1.due_date) {
              //   console.log('sss props test2', task1)
              //   return false
              // }
              return true
            }
            else return false
          }
        ).map((task) =>
          checkReflection(task) &&
          // getStatus(task.step_reflection) === "ongoing" ||
          // getStatus(task.step_reflection) === "just-released" &&
          (
            <TaskComp
              key={`${task.id}-${task.due_date}`}
              title={task.title === 'Tracker' ? 'Host Networking Calls' : task.title}
              date={task.due_date}
              weeklyReflection={task.weekly_reflection > 0}
              stepReflection={task.step_reflection > 0}
              // status={getStatus(task.step_reflection)}
              status={getStatusOfTasks(task)}
              hasDelete={true}
              // hasDelete={!(task.step_reflection || task.weekly_reflection)}
              onEdit = {() => editTask(task.id)}
              id={task.id}
            />
          )
        )
        : [];

    const onFinish = (values) => {
      console.log('sss values', values);
      let timeZoneFormatted = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
      const task = {
        title: values.title,
        assigned_on: values.date ? `${values?.date?.format("YYYY-MM-DDTHH:mm:ss")}${timeZoneFormatted}` : null,
        due_date: values.enddate ? `${values?.enddate?.format("YYYY-MM-DDTHH:mm:ss")}${timeZoneFormatted}` : null,
        duration: values.duration,
        description: values.description,
        hyperlinks: values.hyperlinks
      };
      const updatedData = tasks.map(item => {
        if (item.id === values.id) {
          return {
            ...item,
            title: task.title,
            assigned_on: task.assigned_on ? task.assigned_on : null,
            due_date: task.due_date ? task.due_date : null,
            description: task.description,
            hyperlinks: task.hyperlinks,
          };
        }
        return item; // Return unchanged item if ID doesn't match
      });
      // console.log('sss sorted updatedData', updatedData)
      // setSortedData(updatedData);
      dispatch(updateTasks(updatedData));
      taskId ? dispatch(updateTaskAsync(taskId, task)) :
      dispatch(addTaskAsync(task))
      setModalVisible(false)
    }
    const handleCancel = () => {
      setModalVisible(false)
    }
    const onFinishFailed = () => {

    }
    const onFormChange = (val, allVal) => {
      let start_date = allVal.date;
      var timeZoneFormatted = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
      let temp1 = moment()
      if (allVal?.enddate) {
        temp1 = moment(
          `${allVal?.enddate?.format("YYYY-MM-DD")}T00:00:00${timeZoneFormatted}`
        );
      }
      let end_time = temp1.add(allVal?.duration, "minutes");
      setAddToCal({
        title: allVal.title,
        description: allVal.description,
        location: "",
        startTime: (allVal?.enddate) && `${allVal?.enddate?.format("YYYY-MM-DDTHH:mm:ss")}${timeZoneFormatted}`,
        endTime: `${end_time?.format("YYYY-MM-DD")}T${end_time?.format("HH:mm:ss")}${timeZoneFormatted}`,
      });
    }
    const handleDeleteTask = (id) => {
        dispatch(deleteTaskAsync(id))
        setTaskId(null)
        setModalVisible(false)
    }

    const addNewTask = () => {
        setTaskId(null)
        setModalVisible(true)
        addForm.setFieldsValue({
          id: null,
          title: '',
          date: moment(),
          enddate: moment().add(1, 'week'),
          duration: '60',
          description: '',
          hyperlinks: [""],
        });
    }

    const customLocale = {
      ...enUS,
      lang: {
        ...enUS.lang,
        ok: 'Save', // <-- Change this to whatever you want
      },
    };
    // console.log('sss sorted', { sortedData })
    return (
        <div>
            <div style={{margin: "0px 20px"}}>
                <Card
                    bordered={false}
                    style={{
                        backgroundColor: "#white",
                        boxShadow: "0px 3px 16px 0px #1313131A",
                        borderRadius: "12px",
                        textAlign: "left",
                    }}
                >
                    <div className="h" style={{
                        fontWeight: "800",
                        color:"#111111",
                        fontFamily:'AvenirBook',
                        fontSize: "18px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gridGap: "12px",
                        gap: "12px",
                        }}>
                        {" "}
                        <div className="div-my-tasks-title">
                            {/* Future Release Build */}
                            <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg" className="" />
                            <span className="my-tasks-title">My Tasks</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            // gap: "10.5px",
                          }}
                        >
                            {isDropdownOpen ? (
                                <img
                                src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                                alt="delete icon"
                                className="delete-icon"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={handleDelete}
                              />
                            ) : (
                                <>
                                <DynamicFilter
                                  onFilterChange={handlefilterChange}
                                  filterOptions={filterOptions}
                                  currentFilter={currentFilter}
                                  placeholder="FILTER BY:"
                                  data={originalData}
                                />
                                <DynamicSortDropdown
                                  sortOptions={sortOptions}
                                  // data={originalData}
                                  data={filteredData}
                                  onSortChange={handleSortChange}
                                  currentSortField={currentSortField}
                                  currentSortOrder={currentSortOrder}
                                />
                                </>
                            )}
                        </div>
                        {/* <div
                          className=""
                          style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gridGap: "12px",
                              gap: "12px",
                          }}
                          >
                          <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/myTaskFilterLineIcon.svg" />
                          <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/myTaskSwitchVerticalIcon.svg" />
                        </div> */}
                        {/* My Tasks */}
                    </div>
                    <ul className="tasks-list">
                        {sortedData}
                        {/* {dummyTasks()} */}
                        {/* {tasksList} */}
                        <br/>
                    </ul>
                    <button
                        type="primary"
                        size="large"
                        className="button-main my-tasks-add-new-buttom element-hide-temporary" //Future Release Build
                    >&#43;&nbsp;Add New Task</button>
                    <button
                        type="primary"
                        onClick={addNewTask}
                        // className="add-new"
                        className="button-main my-tasks-add-new-buttom"
                    >
                        <PlusOutlined/> Add New Task

                    </button>
                </Card>
            </div>

            <Modal
              title=""
              visible={modalVisible}
              onCancel={handleCancel}
              footer={false}
              width="550px"
              destroyOnClose={true}
              closeIcon={<CloseOutlined className="close-icon"/>}
              className="edit-task-modal"
            >
              <h2 class="modal-title">{taskId ? "Edit Task" : "Add New Task" }</h2>
              <Form
                name="add-task-form"
                initialValues={{}}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={addForm}
                layout="vertical"
                onValuesChange={onFormChange}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label="Id"
                      name="id"
                      hidden
                      className="edit-task-items"
                    >
                      <Input size="large" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      label="Name"
                      name="title"
                      className="edit-task-items"
                      rules={[{required: true, message: "Please input your title!"}]}
                    >
                      <Input placeholder="Title of my task" size="large" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      name="description"
                      className="edit-task-items"
                      label="Description"
                    >
                      <TextArea placeholder="Describe the task" autoSize={{ minRows: 2, maxRows: 5 }} style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.List name="hyperlinks">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field, index) => (
                            <Form.Item
                              key={field.key}
                              label={index === 0 ? "Hyperlink" : ""}
                              required={false}
                              className="edit-task-items"
                              style={{ marginBottom: index === fields.length - 1 ? 24 : 15 }}
                            >
                              <Form.Item
                                {...field}
                                noStyle
                              >
                                <Input
                                  placeholder="Paste any helpful links here"
                                  size="large"
                                  style={{
                                    padding: "13.5px 11px",
                                    borderRadius: "12px",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    backgroundColor: "#E8F4F7",
                                    border: "1px solid #007bff",
                                    marginBottom: "10px"
                                  }}
                                    // suffix={
                                    //   index > 0 ? (
                                    //     <img src="https://django-woken-static.s3.amazonaws.com/static/media/delete.037bee2b.svg" width="16px" onClick={() => remove(field.name)}></img>
                                    //   ) : null
                                    // }
                                  />
                              </Form.Item>
                              {
                                index === 0 &&
                                <button
                                  type="button"
                                  onClick={() => add()}
                                  style={{
                                    color: "#8E8E8E",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    fontSize: "17px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    columnGap: "5px",
                                    // marginBottom: "20px",
                                  }}
                                >
                                  <PlusOutlined /> Add more
                                </button>
                              }
                            </Form.Item>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={12} hidden>
                        <Form.Item name="date" className="edit-task-items" label="Start Date">
                          <DatePicker locale={customLocale} showTime={{ use12Hours: true, format: 'hh:mm A' }} format="MM/DD/YYYY hh:mm A" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}/>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="enddate" className="edit-task-items" label="Goal Date" rules={[
                          // ({ getFieldValue }) => ({
                          //   validator(_, value) {
                          //     const startDate = getFieldValue("date");
                          //     if (!value || !startDate || value.isAfter(startDate)) {
                          //       return Promise.resolve();
                          //     }
                          //     return Promise.reject(new Error("End Date must be after Today"));
                          //   },
                          // }),
                        ]}>
                          <DatePicker locale={customLocale} showTime={{ use12Hours: true, format: 'hh:mm A' }} format="MM/DD/YYYY hh:mm A" style={{ padding: "13.5px 11px", boxSizing: "border-box", width: "100%", backgroundColor: "#E8F4F7", border: "1px solid #007bff" }}/>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row hidden>
                  <Col span={12} hidden>
                    <Form.Item
                      label="Duration (minutes)"
                      name="duration"
                      className="edit-task-items"
                    >
                      <InputNumber min={30} max={60 * 24} step={30}/>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={8}>
                      <div className="button-group" style={{ justifyContent: "flex-start" }}>
                     
                        {
                          taskId ? (
                            <Popconfirm
                              title="Are you sure you want to delete?"
                              onConfirm={() => {
                                handleDeleteTask(taskId);
                              }}
                            >
                              <button
                                className="button-secondary"
                                disabled={!taskId}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                >
                                  <DeleteOutlined/>&nbsp;&nbsp;Delete
                              </button>
                            </Popconfirm>
                          ) : ("")
                        }
                      </div>
                      </Col>
                      <Col span={16}>
                        <div className="button-group">
                          <button
                            className="button-secondary"
                            style={{
                              width: "100%"
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                          <button
                            type="primary"
                            className="button-main"
                            htmlType="submit"
                            style={{
                              width: "100%"
                            }}
                          >
                            Save
                          </button>

                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div style={{marginBottom: "20px", marginTop: "20px"}}>
                  {
                    React.createElement(() => (
                      <AddToCalendar
                        event={addToCal}
                        listItems={[{google: "Add to Google Calendar"}]}
                        optionsOpen={true}
                      />
                    ))
                  }
                </div>

              </Form>
            </Modal>
        </div>
    );
};

export default Mytasks;